/**
 * [catsInOneCntForLine description]
 * @param  {object} obj   the whole data
 * @param  {string} names country name
 * @return {array}         as below
 */
/*
[
  {
    name: "Animals",
    data: [56.33, 65, 25, ...]
  }, 
  {
    name: "Dairy",
    data: [56.33, 65, 25, ...]
  },
]
*/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.catsInOneCntForLine = catsInOneCntForLine;

function catsInOneCntForLine(obj, name) {
  var output = [];

  var hash = {};

  var _loop = function (cat) {
    for (var subCat in obj[cat]) {

      if (obj[cat][subCat][name] === undefined) continue;

      if (hash[cat] === undefined) hash[cat] = [];
      obj[cat][subCat][name].forEach(function (d, i) {
        if (hash[cat][i] === undefined) hash[cat][i] = 0;
        hash[cat][i] += d;
      });
    }
  };

  for (var cat in obj) {
    _loop(cat);
  }

  var _loop2 = function (key) {

    var arr = [];
    hash[key].forEach(function (d) {
      arr.push(parseFloat(d.toFixed(1)));
    });

    output.push({
      name: key,
      data: arr
    });
  };

  for (var key in hash) {
    _loop2(key);
  }

  output.sort(function (a, b) {
    return b.data.reduce(function (b1, b2) {
      return b1 + b2;
    }) - a.data.reduce(function (a1, a2) {
      return a1 + a2;
    });
  });

  return output;
}
//# sourceMappingURL=data:application/json;base64,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